/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React from 'react';

import styles from './ReturnToHereButton.module.scss';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { returnToHereClicked } from '../chatSlice';

interface ReturnToHereButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
}

export function ReturnToHereButton({ children, onClick }: ReturnToHereButtonProps) {
  return (
    <div className={styles.button} onClick={onClick}>
      {children}
    </div>
  );
}

export function ReturnToHereButtonList({ lastMessageIndex }: { lastMessageIndex: number }) {
  const returnToHere = useAppSelector((state) => state.chat.returnToHere);
  const dispatch = useAppDispatch();
  if (!returnToHere.length) {
    return null;
  }
  return (
    <div className={styles.container}>
      {returnToHere.map((returnToHereInfo, index) =>
        lastMessageIndex <= returnToHereInfo.messageIndex || !returnToHereInfo.info.text ? null : (
          <ReturnToHereButton key={index} onClick={() => dispatch(returnToHereClicked(index))}>
            {returnToHereInfo.info.text}
          </ReturnToHereButton>
        )
      )}
    </div>
  );
}
